// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminPanelTable_table_wrap__byna7 {
  max-width: 100%;
  overflow-x: scroll;
  margin-top: 10px;
  border-top: 1px solid var(--border-default-color);
}
.adminPanelTable_table_wrap__byna7 .adminPanelTable_inactive_row__Sql7i td {
  color: #7c7c7c !important;
}
.adminPanelTable_table_wrap__byna7 .adminPanelTable_inactive_row__Sql7i td div {
  color: #7c7c7c !important;
}
.adminPanelTable_table_wrap__byna7::-webkit-scrollbar {
  height: 3px;
}
.adminPanelTable_table_wrap__byna7::-webkit-scrollbar-thumb {
  background: #c2c3c5;
}
.adminPanelTable_table_wrap__byna7 table {
  border-spacing: 0;
  width: 100%;
}
.adminPanelTable_table_wrap__byna7 thead tr th {
  text-align: left;
  background-color: var(--main-bg-color);
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  text-transform: uppercase;
  max-width: 180px;
}
.adminPanelTable_table_wrap__byna7 thead tr th div {
  width: max-content;
}
.adminPanelTable_table_wrap__byna7 thead tr th span {
  margin-right: 5px;
}
.adminPanelTable_table_wrap__byna7 thead tr th,
.adminPanelTable_table_wrap__byna7 tbody tr td {
  padding: 3px 10px;
}
.adminPanelTable_table_wrap__byna7 tbody td {
  width: max-content;
}
.adminPanelTable_table_wrap__byna7 thead tr th:first-child,
.adminPanelTable_table_wrap__byna7 tbody tr td:first-child {
  padding-left: 20px;
  position: sticky;
  left: 0;
  background-color: var(--main-bg-color);
  box-sizing: border-box;
  background-clip: padding-box;
}
.adminPanelTable_table_wrap__byna7 thead tr th:first-child span,
.adminPanelTable_table_wrap__byna7 tbody tr td:first-child span {
  width: max-content;
  word-break: keep-all;
}
.adminPanelTable_table_wrap__byna7 tbody tr:nth-child(odd) td:first-child {
  background-color: #fafbfd;
}
.adminPanelTable_table_wrap__byna7 thead tr th:last-child,
.adminPanelTable_table_wrap__byna7 tbody tr td:last-child {
  min-width: 80px;
  padding-right: 10px;
}
.adminPanelTable_table_wrap__byna7 tbody tr:nth-child(even) {
  background-color: var(--main-bg-color);
}
.adminPanelTable_table_wrap__byna7 th,
.adminPanelTable_table_wrap__byna7 td {
  border-bottom: 1px solid var(--border-default-color);
  padding: 0px;
  height: 60px;
}
.adminPanelTable_table_wrap__byna7 .adminPanelTable_cursor_pointer__flN28 {
  cursor: pointer;
}
@media (max-width: 1440px) {
  .adminPanelTable_table_wrap__byna7 thead tr th:first-child,
  .adminPanelTable_table_wrap__byna7 tbody tr td:first-child {
    padding-left: 15px;
  }
  .adminPanelTable_table_wrap__byna7 th {
    height: 40px;
  }
  .adminPanelTable_table_wrap__byna7 td {
    height: 50px;
  }
}
@media (max-width: 991px) {
  .adminPanelTable_table_wrap__byna7 thead tr th:first-child,
  .adminPanelTable_table_wrap__byna7 tbody tr td:first-child {
    padding-left: 10px;
  }
  .adminPanelTable_table_wrap__byna7 thead tr th {
    font-size: 14px;
    max-width: 170px;
    width: max-content;
  }
  .adminPanelTable_table_wrap__byna7 tbody tr td {
    font-size: 12px;
    word-break: break-all;
  }
  .adminPanelTable_table_wrap__byna7 tbody tr td:first-child > div {
    width: 100%;
  }
  .adminPanelTable_table_wrap__byna7 tbody tr td div {
    width: max-content;
    max-width: 170px;
  }
  .adminPanelTable_table_wrap__byna7 th {
    height: 35px;
  }
  .adminPanelTable_table_wrap__byna7 td {
    height: 40px;
  }
}

.adminPanelTable_pagination_bar__wFBeV {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 10px 0 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/AdminPanel/AdminPanelTable/adminPanelTable.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AACF;AAEI;EACE,yBAAA;AAAN;AACM;EACE,yBAAA;AACR;AAIE;EACE,WAAA;AAFJ;AAIE;EACE,mBAAA;AAFJ;AAKE;EAGE,iBAAA;EACA,WAAA;AALJ;AAQE;EACE,gBAAA;EACA,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AANJ;AAQI;EACE,kBAAA;AANN;AASI;EACE,iBAAA;AAPN;AAUE;;EAEE,iBAAA;AARJ;AAWE;EACE,kBAAA;AATJ;AAYE;;EAEE,kBAAA;EACA,gBAAA;EACA,OAAA;EACA,sCAAA;EAEA,sBAAA;EAEA,4BAAA;AAZJ;AAeI;;EACE,kBAAA;EACA,oBAAA;AAZN;AAgBE;EACE,yBAAA;AAdJ;AAiBE;;EAEE,eAAA;EACA,mBAAA;AAfJ;AAwBE;EACE,sCAAA;AAtBJ;AAyBE;;EAEE,oDAAA;EACA,YAAA;EACA,YAAA;AAvBJ;AA0BE;EACE,eAAA;AAxBJ;AA2BE;EACE;;IAEE,kBAAA;EAzBJ;EA2BE;IACE,YAAA;EAzBJ;EA2BE;IACE,YAAA;EAzBJ;AACF;AA4BE;EACE;;IAEE,kBAAA;EA1BJ;EA4BE;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;EA1BJ;EA6BE;IACE,eAAA;IACA,qBAAA;EA3BJ;EA8BM;IACE,WAAA;EA5BR;EAgCI;IACE,kBAAA;IACA,gBAAA;EA9BN;EAkCE;IACE,YAAA;EAhCJ;EAkCE;IACE,YAAA;EAhCJ;AACF;;AAoCA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AAjCF","sourcesContent":[".table_wrap {\n  max-width: 100%;\n  overflow-x: scroll;\n  margin-top: 10px;\n  border-top: 1px solid var(--border-default-color);\n\n  .inactive_row {\n    td {\n      color: #7c7c7c !important;\n      div {\n        color: #7c7c7c !important;\n      }\n    }\n  }\n\n  &::-webkit-scrollbar {\n    height: 3px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #c2c3c5;\n  }\n\n  table {\n    // border-top: 1px solid var(--border-default-color);\n    // border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n  }\n\n  thead tr th {\n    text-align: left;\n    background-color: var(--main-bg-color);\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    align-items: center;\n    text-transform: uppercase;\n    max-width: 180px;\n\n    div {\n      width: max-content;\n    }\n\n    span {\n      margin-right: 5px;\n    }\n  }\n  thead tr th,\n  tbody tr td {\n    padding: 3px 10px;\n  }\n\n  tbody td {\n    width: max-content;\n  }\n\n  thead tr th:first-child,\n  tbody tr td:first-child {\n    padding-left: 20px;\n    position: sticky;\n    left: 0;\n    background-color: var(--main-bg-color);\n    // border-bottom: none;\n    box-sizing: border-box;\n    // box-shadow: 0 1px 0 0 var(--border-default-color);\n    background-clip: padding-box;\n    // border-bottom: 1px solid var(--border-default-color);\n\n    span {\n      width: max-content;\n      word-break: keep-all;\n    }\n  }\n\n  tbody tr:nth-child(odd) td:first-child {\n    background-color: #fafbfd;\n  }\n\n  thead tr th:last-child,\n  tbody tr td:last-child {\n    min-width: 80px;\n    padding-right: 10px;\n\n    // div {\n    //   button {\n    // margin: 0 15px;\n    //   }\n    // }\n  }\n\n  tbody tr:nth-child(even) {\n    background-color: var(--main-bg-color);\n  }\n\n  th,\n  td {\n    border-bottom: 1px solid var(--border-default-color);\n    padding: 0px;\n    height: 60px;\n  }\n\n  .cursor_pointer {\n    cursor: pointer;\n  }\n\n  @media (max-width: 1440px) {\n    thead tr th:first-child,\n    tbody tr td:first-child {\n      padding-left: 15px;\n    }\n    th {\n      height: 40px;\n    }\n    td {\n      height: 50px;\n    }\n  }\n\n  @media (max-width: 991px) {\n    thead tr th:first-child,\n    tbody tr td:first-child {\n      padding-left: 10px;\n    }\n    thead tr th {\n      font-size: 14px;\n      max-width: 170px;\n      width: max-content;\n    }\n\n    tbody tr td {\n      font-size: 12px;\n      word-break: break-all;\n\n      &:first-child {\n        & > div {\n          width: 100%;\n        }\n      }\n\n      div {\n        width: max-content;\n        max-width: 170px;\n      }\n    }\n\n    th {\n      height: 35px;\n    }\n    td {\n      height: 40px;\n    }\n  }\n}\n\n.pagination_bar {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin: 10px 0 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table_wrap": `adminPanelTable_table_wrap__byna7`,
	"inactive_row": `adminPanelTable_inactive_row__Sql7i`,
	"cursor_pointer": `adminPanelTable_cursor_pointer__flN28`,
	"pagination_bar": `adminPanelTable_pagination_bar__wFBeV`
};
export default ___CSS_LOADER_EXPORT___;
